import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['Juan', 'Pedro', 'Carlos', 'Miguel', 'Andrés', 'Diego', 'Luis', 'Roberto', 'Fernando', 'José'];
const LOCATIONS = [{
  city: 'Ciudad de México',
  country: 'México'
}, {
  city: 'Bogotá',
  country: 'Colombia'
}, {
  city: 'Lima',
  country: 'Perú'
}, {
  city: 'Buenos Aires',
  country: 'Argentina'
}, {
  city: 'Santiago',
  country: 'Chile'
}, {
  city: 'Guadalajara',
  country: 'México'
}, {
  city: 'Medellín',
  country: 'Colombia'
}, {
  city: 'Quito',
  country: 'Ecuador'
}, {
  city: 'Caracas',
  country: 'Venezuela'
}, {
  city: 'Montevideo',
  country: 'Uruguay'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    country: ''
  });
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  useEffect(() => {
    const showRandomPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomLoc = LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)];
      setData({
        name: randomName,
        city: randomLoc.city,
        country: randomLoc.country
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showRandomPopup, 5000);
    // Loop
    const interval = setInterval(() => {
      // Random interval between 8-15 seconds
      const randomDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showRandomPopup, randomDelay);
    }, 15000); // Base interval
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-40 max-w-sm w-full animate-in slide-in-from-bottom-5 fade-in duration-500 cursor-pointer" onClick={scrollToPurchase} data-id="element-99">
      <div className="bg-white text-slate-900 p-4 rounded-lg shadow-2xl border-l-4 border-green-500 flex items-start gap-3 relative overflow-hidden" data-id="element-100">
        <div className="absolute top-2 right-2 text-slate-400 hover:text-slate-600" onClick={e => {
        e.stopPropagation();
        setIsVisible(false);
      }} data-id="element-101">
          <X size={14} data-id="element-102" />
        </div>
        <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-103">
          <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-104" />
        </div>
        <div data-id="element-105">
          <p className="font-bold text-sm text-slate-800" data-id="element-106">
            ¡Nueva compra verificada!
          </p>
          <p className="text-sm text-slate-600 mt-1" data-id="element-107">
            <span className="font-semibold" data-id="element-108">{data.name}</span> de {data.city},{' '}
            {data.country}
          </p>
          <p className="text-xs text-slate-400 mt-2" data-id="element-109">
            Acaba de comprar el libro
          </p>
        </div>
      </div>
    </div>;
}